import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";
interface Occurrences {
  delay: number;
  shipper: string;
}
export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize, componentProperty, generateRedirectUrl } =
    useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(380);
  const [widthChart, setWidthChart] = useState(300);
  const [labels, setLabels] = useState<string[]>([]);
  const [dataChart, setDataChart] = useState<number[]>([]);
  const [total, setTotal] = useState<number>(0);
  const { mode } = useParams();

  useEffect(() => {
    const dl: number[] = [],
      rg: string[] = [];
    const sizes = getSizesComponent({ id: "chart-shipper-count" });
    data.delays.forEach((route: Occurrences) => {
      dl.push(route.delay);
      rg.push(route.shipper);
    });
    if (dl && dl.length !== 0) {
      const fakesCol = Math.floor(sizes.height / dl.length / 230);
      if (fakesCol > 0) {
        for (let i = 1; i <= fakesCol; i++) {
          dl.push(0);
        }
      }
    }
    setLabels(rg);
    setDataChart(dl);
  }, [data]);

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-shipper-count" });
    if (dataChart && dataChart.length !== 0) {
      setTotal(
        dataChart.reduce(function (soma: number, i: number) {
          return +soma + +i;
        })
      );
    }

    if (sizes.width < 345) {
      setFontSize({ id: "chart-shipper-count", width: sizes.width });
    }
    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, [dataChart]);

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      toolbar: {
        show: false,
      },
      events: {
        dataPointSelection: async (event, chartContext, config) => {
          if (
            mode === "view" &&
            componentProperty({
              id: "chartShipperCount",
              property: "redirect",
            })
          ) {
            window.open(
              await generateRedirectUrl("chartShipperCount", {
                redirectTowerToDelays: true,
                routeDelay: '1',
                shipper_group: labels[config.dataPointIndex]
              }),
              "_blank"
            );
          }
        },
      },
    },
    plotOptions: {
      bar: {
        barHeight: "80%",
        distributed: true,
        horizontal: true,
        dataLabels: { position: "bottom" },
      },
    },
    colors: [
      "#B2D4EF",
      "#E9B825",
      "#FFAF8F",
      "#5894C2",
      "#FFDA6B",
      "#E95D25",
      "#80B3DA",
      "#FFE38F",
    ],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      formatter: function (val, opt) {
        if (labels[opt.dataPointIndex]) {
          return labels[opt.dataPointIndex] + ":  " + val;
        }
        return "";
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: { position: "bottom" },
        },
      },
    ],
    yaxis: {
      labels: {
        show: false,
      },
    },
    xaxis: {
      max: Math.max(...dataChart),
      range: 7,
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    labels: labels,
    tooltip: { enabled: false },
    legend: { show: false },
  };
  const series = [
    {
      data: dataChart,
    },
  ];

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Atrasos - Quantidade por embarcador ${total}`}
        clickable={componentProperty({
          id: "chartShipperCount",
          property: "redirect",
        })}
        id="chart-shipper-count"
      />

      <div id={"fixedBox"}>
        <div id="chart">
          <Chart
            type="bar"
            options={options}
            series={series}
            height={heightChart}
            width={widthChart}
          />
        </div>
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};
